import React, { MutableRefObject } from 'react'
import styles from '~/styles/molecules/navigation/navigation.module.scss'
import { ChildProps } from '~/common/define/props'
import { ColorWeight, lightenColor, SpaceColor } from '~/common/define/color'
import { addClass } from '~/common/utils/html'

interface Props extends ChildProps {
  borderColor: SpaceColor
  top?: boolean
  bottom?: boolean
  sticky?: boolean
  borderRef?: MutableRefObject<any>
}

const NavigationBorderFrame = ({children, borderColor, top = false, bottom = false, sticky = false, borderRef = null}: Props) => {
  return (
    <div className={addClass(styles.borderTop, top) + addClass(styles.borderBottom, bottom) + addClass(styles.borderSticky, !!sticky)}
         ref={borderRef}>
      {children}
      <style jsx>{`
        div {
          border-color: ${borderColor ? lightenColor(borderColor, ColorWeight.WELTER) : 'transparent'};
        }
      `}</style>
    </div>
  )
}

export default NavigationBorderFrame